export const applyCustomBreadcrumbsCss = () => {
  const hostEl = document.querySelector("dsy-breadcrumbs");
  const shadowRoot = hostEl?.shadowRoot;
  if (!shadowRoot) return;

  breadcrumbsCss(shadowRoot);
};

const breadcrumbsCss = (breadcrumbsShadowRoot: ShadowRoot) => {
  const breadcrumbsContainer = breadcrumbsShadowRoot.querySelector("nav") as HTMLElement;
  if(!breadcrumbsContainer)return;

  const breadcrumbItems = breadcrumbsContainer.querySelectorAll(".breadcrumbs") as NodeListOf<HTMLElement>;

  if (!breadcrumbsShadowRoot.querySelector("style[data-breadcrumbs-size]")) {
    const style = document.createElement("style");
    style.setAttribute("data-breadcrumbs-size", "");
    style.textContent = "* { font-size: 14px !important; }";
    breadcrumbsShadowRoot.appendChild(style);
  }

  if(breadcrumbItems && breadcrumbItems.length > 0){
    const firstBreadcrumbItem = breadcrumbItems[0];
    firstBreadcrumbItem.style.pointerEvents = "none";
    firstBreadcrumbItem.style.color = "#667790";
  }

  const separatorItems = breadcrumbsContainer.querySelectorAll(".separator") as NodeListOf<HTMLElement>;
  if(separatorItems){
    separatorItems.forEach((separator) => {
      separator.style.color = "#667790";
    });
  }
};